import config from '../config';

let initialized = false;

/**
 * Every Meta Pixel init goes through here. Turns off fbevents.js's automatic
 * SPA PageView: it fires on every pushState/replaceState/popstate without an
 * eventID, so Meta can never dedupe it against the PageView the relay sends to
 * CAPI. FacebookTrackingEventHandler tracks each committed navigation instead.
 * fbevents.js reads the flag once, when it boots, so it has to be set on the
 * window.fbq stub init() creates, before the injected script has loaded.
 *
 * @param {object} ReactPixel default export of @bettercart/react-facebook-pixel
 * @param {object} [advancedMatching] user data for advanced matching
 */
export const initFacebookPixel = (ReactPixel, advancedMatching = {}) => {
  ReactPixel.init(config.facebook.pixel.id || '', advancedMatching, config.facebook.pixel.options);
  initialized = true;
  if (window.fbq) window.fbq.disablePushState = true;
};

/**
 * ReactPixel silently drops every track call made before its first init() —
 * they never reach window.fbq. Check this before tracking instead of
 * `ReactPixel.init.length`, which is the function's arity (1), not its state.
 *
 * @returns {boolean} whether initFacebookPixel has run in this page
 */
export const isFacebookPixelInitialized = () => initialized;
